import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import {
  getAgentsByUpdatedPresence,
  getSortedAgentsByAvailability,
} from 'dashboard/helper/agentHelper';

const KAPTION_ASSISTANT_REGEX = /@assistants\.kaptionai\.com$/i;

export function useAssistantsList(includeNoneAssistant = true) {
  const { t } = useI18n();
  const currentUser = useMapGetter('getCurrentUser');
  const currentChat = useMapGetter('getSelectedChat');
  const currentAccountId = useMapGetter('getCurrentAccountId');
  // NOTICE: KAPTION-INTEGRATION
  const assignableAssistantsGetter = useMapGetter(
    'inboxAssignableAssistants/getAssignableAssistants'
  );

  const inboxId = computed(() => currentChat.value?.inbox_id);
  const inboxKey = computed(() => {
    if (!inboxId.value) {
      return null;
    }
    return `${inboxId.value}`;
  });

  const selectedAssistant = computed(() => {
    const assignee = currentChat.value?.meta?.assignee;
    if (!assignee || !assignee.email) {
      return null;
    }
    return KAPTION_ASSISTANT_REGEX.test(assignee.email) ? assignee : null;
  });

  const hasAssistantSelected = computed(() => !!selectedAssistant.value);

  const createNoneAssistant = () => ({
    confirmed: true,
    name: t('AGENT_MGMT.MULTI_SELECTOR.LIST.NONE') || 'None',
    id: 0,
    role: 'assistant',
    account_id: 0,
    email: 'None',
  });

  const assignableAssistants = computed(() => {
    if (!inboxKey.value) {
      return [];
    }
    return assignableAssistantsGetter.value(inboxKey.value);
  });

  const assistantsList = computed(() => {
    const assistants = assignableAssistants.value || [];
    const normalizedAssistants = getAgentsByUpdatedPresence(
      assistants,
      currentUser.value,
      currentAccountId.value
    );

    const sortedAssistants =
      getSortedAgentsByAvailability(normalizedAssistants);

    return [
      ...(includeNoneAssistant && hasAssistantSelected.value
        ? [createNoneAssistant()]
        : []),
      ...sortedAssistants,
    ];
  });

  return {
    assistantsList,
    assignableAssistants,
    selectedAssistant,
  };
}
